import { render } from "./TournamentPlayersPrize.vue?vue&type=template&id=94b42506&ts=true"
import script from "./TournamentPlayersPrize.vue?vue&type=script&lang=ts"
export * from "./TournamentPlayersPrize.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/Admin/Reports/TournamentPlayersPrize.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "94b42506"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('94b42506', __exports__)) {
    api.reload('94b42506', __exports__)
  }
  
  module.hot.accept("./TournamentPlayersPrize.vue?vue&type=template&id=94b42506&ts=true", () => {
    api.rerender('94b42506', render)
  })

}


export default __exports__